import { GridColDef } from '@rossum/ui/x-data-grid-pro';
import { ErrorNote } from './components/ErrorNote';
import { RenderDate } from './components/RenderDate';
import { StatusChip } from './components/StatusChip';
import { TextCell } from './components/TextCell';
import { Fields, filterOperators, metaColumnDataTypesMap } from './operators';

const DEFAULT_COLUMN_CONFIG = {
  filterable: true,
  pinnable: false,
};

export const useColumns = ({ statuses }: { statuses: string[] }) => {
  const columns: Array<GridColDef> = [
    {
      field: 'status' satisfies Fields,
      headerName: 'Status',
      renderCell: StatusChip,
      width: 160,
      filterOperators: filterOperators.singleSelect,
      type: metaColumnDataTypesMap.status,
      valueOptions: statuses,
    },
    {
      field: 'dataset_name' satisfies Fields,
      headerName: 'Dataset Name',
      flex: 1,
      filterOperators: filterOperators.string,
      type: metaColumnDataTypesMap.dataset_name,
      renderCell: TextCell,
    },
    {
      field: 'message' satisfies Fields,
      headerName: 'Errors',
      renderCell: ErrorNote,
      width: 70,
      filterable: false,
    },
    {
      field: 'type' satisfies Fields,
      headerName: 'Operation Type',
      width: 130,
      filterOperators: filterOperators.string,
      type: metaColumnDataTypesMap.type,
      renderCell: TextCell,
    },
    {
      field: 'document_name' satisfies Fields,
      headerName: 'Document Name',
      width: 150,
      filterOperators: filterOperators.string,
      type: metaColumnDataTypesMap.document_name,
      renderCell: TextCell,
    },
    {
      field: 'records' satisfies Fields,
      headerName: 'Records',
      width: 100,
      renderCell: TextCell,
      filterOperators: filterOperators.number,
      type: metaColumnDataTypesMap.records,
    },
    {
      field: 'created' satisfies Fields,
      headerName: 'Create',
      width: 120,
      renderCell: RenderDate,
      filterOperators: filterOperators.date,
      type: metaColumnDataTypesMap.created,
    },
    {
      field: 'updated' satisfies Fields,
      headerName: 'Last Change',
      width: 120,
      renderCell: RenderDate,
      filterOperators: filterOperators.date,
      type: metaColumnDataTypesMap.updated,
    },
  ];

  return columns.map(col => ({ ...DEFAULT_COLUMN_CONFIG, ...col }));
};
